<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sradio/SradioEditor'
export default {
  name: 'SSexEditor',
  extends: compoment
}
</script>
